import RegisterSuccessPhD from "./RegisterSuccessPhD";
export default RegisterSuccessPhD;
